export function waitForImages(doc: Document, timeoutMs: number): Promise<void> {
  const pending = Array.from(doc.images)
    .filter((image) => !image.complete)
    .map(
      (image) =>
        new Promise<void>((resolve) => {
          image.addEventListener('load', () => resolve(), { once: true });
          image.addEventListener('error', () => resolve(), { once: true });
        }),
    );

  if (!pending.length) {
    return Promise.resolve();
  }

  const timeout = new Promise<void>((resolve) => setTimeout(resolve, timeoutMs));
  return Promise.race([Promise.all(pending).then(() => undefined), timeout]);
}
